import { Flex, Modal, Space, Typography } from "antd"

import Icon from "../../../Icon"
import ButtonComponent from "../../Button"

import "./styles.less"

const { Text } = Typography

const TwoFactorSuccessModal = ({
  open,
  onClose,
  onSuccess,
  t,
  buttonText = "Done",
  closable = true,
  maskClosable = true
}) => {
  return (
    <Modal
      open={open}
      centered
      width={442}
      footer={null}
      closable={closable}
      maskClosable={maskClosable}
      onCancel={onClose}
      rootClassName="two-factor-success-modal"
      classNames={{ content: "clear-bg" }}
      closeIcon={closable ? <Icon role="icon" type="notification_close" /> : null}
    >
      <Space direction="vertical" size={16} className="two-factor-success">
        <div className="two-factor-success-icon">
          <Icon type="success_full" style={{ fontSize: 40 }} />
        </div>

        <Space direction="vertical" size={4}>
          <Text strong className="two-factor-success-title">
            {t("Two-factor authentication is set up")}
          </Text>

          <Text type="secondary">{t("Two-factor authentication is now enabled.")}</Text>
        </Space>

        <Flex justify="flex-end" style={{ width: "100%" }}>
          <ButtonComponent type="primary" onClick={onSuccess || onClose}>
            {t(buttonText)}
          </ButtonComponent>
        </Flex>
      </Space>
    </Modal>
  )
}

export default TwoFactorSuccessModal
